import axios from "@/plugins/axios";

export default {
    actions: {
        fetchSaleEmployeeMonthly(context, searchItem) {
            let url = "sale_employee_monthlies?page="  + searchItem.page

            if (!context.state.saleEmployeeMonthly.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byTotalSum) {
                url = url + '&order[totalSum]=desc'
            } else if (searchItem.byAverage) {
                url = url + '&order[average]=desc'
            } else if (searchItem.byReceiptAmount) {
                url = url + '&order[amount]=desc'
            } else if (searchItem.byIncome) {
                url = url + '&order[income]=desc'
            }

            if (searchItem.before) {
                url = url + '&date[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&date[after]=' + searchItem.after
            }

            if (searchItem.givenName) {
                url = url + "&person.givenName=" + searchItem.givenName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleEmployeeMonthly', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateSaleEmployeeMonthly(state, data) {
            state.saleEmployeeMonthly = data
            state.saleEmployeeMonthly.isNeedFetch = false
        },
    },
    state: {
        saleEmployeeMonthly: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSaleEmployeeMonthly(state) {
            return state.saleEmployeeMonthly.models
        },
        getSaleEmployeeMonthlyTotalCount(state) {
            return state.saleEmployeeMonthly.totalItems
        },
    },
}
